<template>
  <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    <div class="boxShadow setBorderRadius heig-frame-equipment-group">
      <b-row no-gutters>
        <b-col md="12" class="heig-frame-child">
          <gofix-card class="mb-0 heig-frame-child" fullContent>
            <gofix-default-table :settings="tableConfig"
                                 :table-items="tableItems"
                                 @load-items="getTableData"
                                 @import-items="importDate"
                                 ref="gofixTable">
              <template slot="gofix_table:before-import-modal" >
                <b-form-group>
                  <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="importData.check" ref="file-input1" accept=".csv" v-model="importData.file" >
                    <template slot="file-name" slot-scope="{ names }">
                      <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                  </b-form-file>
                </b-form-group>
                <hr/>
              </template>
            </gofix-default-table>
          </gofix-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { filters } from '@/_filterVar.js'
import { mapGetters } from 'vuex';



export default {
  name: 'nlt-covered-site',
  data() {
    let filter =  JSON.parse(JSON.stringify(filters['covered_site']));
    return {
      tableConfig:{
        name: 'nlt_covered_site',
        controls:{
          delete:false,
          create:false
        },
        filter: filter,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: false,
        sortColumn: "id",
        sortDirection: "desc",
      },
      tableItems:[],
      modals:{
        import:{
          property_root_ids: [],
          contracts: []
        }
      },
      importData:{
        open: false,
        loading: false,
        file: null,
        fileName: "Click Browse to upload file"
      },

    }
  },
  watch: {
    "importData.file": function(val, old) {
      if (val) {
        let arrExtionsionAccept = ['csv']
        let split = val.name.split('.');
        let extension = split[split.length - 1].toLowerCase();
        if(!arrExtionsionAccept.includes(extension)) {
          this.$refs['file-input1'].reset();
          return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
        }
        return this.importData.fileName = val.name;
      }
      return this.importData.fileName = 'Click Browse to upload file'
    },
  },
  computed: {
    ...mapGetters({
      ClientContractID: 'ContractController/ClientContractID',
    })
  },
  created () {
    this.getNLTContract()
  },

  methods: {
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      await this.$store.dispatch("NLTCoveredSiteController/getItems", tableRequest)
          .then(response => {
            this.tableItems = response.items;
            this.tableConfig.total = response.total;
            resolve(response);
          })
          .catch(err => {
            this.$alertNotification("Can not load the data", "danger");
            reject();
          })
    },
    async importDate(callback){

      if(this.importData.loading) return ;
      if (!this.importData.file) {
        return this.$alertNotification("Please choose file to import", "danger");
      }
      this.importData.loading = true;

      const {file, resolve, reject} = await callback();
      await this.$store.dispatch(`NLTCoveredSiteController/import`, {
        file_1: this.importData.file,
        file_2: file,
      })
          .then(response => {
            let variant = 'success';
            let msg = "Successfully imported";
            this.$alertNotification(msg, variant,'Import');
            resolve();
          })
          .catch(error => {
            reject(error);
          });
    },
    getNLTContract(){
      this.$store.dispatch(`ContractController/getNLTContract`)
          .then(response => {
            this.modals.import.contracts = response
          })
          .catch(error => {
            this.modals.import.contracts = []
          });
    },
    changeFile(){
      this.importData.check = this.importData.file ? false : true;
    }
  }
}
</script>
